import $http from '@/api/index'
import axios from 'axios'
import { getToken } from '../../../util/auth'
const cookieUser = getToken()
//TODO:获取所有的知识分类
export function GetAllKnowledgeClass() {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetAllKnowledgeClass',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

//TODO:获取所有的标签关键字
export function GetAllKnowledgeTags() {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetAllKnowledgeTags',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

//TODO:获取所有知识类型
export function GetAllKnowledgeType() {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetAllKnowledgeType',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

//TODO:新增知识
export function AddKnowledge(formData) {
  let getUrl = {
    method: 'post',
    url: 'KMS/AddKnowledge',
    requestType: 2,
    isFormData: true
  }
  let params = formData
  return $http(getUrl, params)
}

//TODO:检索知识
export function SearchKnowledge(searchPara) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/SearchKnowledge',
    requestType: 2
  }
  let params = searchPara
  return $http(getUrl, params)
}

//TODO:修改知识 参数为：KM_KNOWLEDGE类型 Knowledge,PersonInfo类型 Person
export function UpdateKnowledge(Knowledge, Person, fileList) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/UpdateKnowledge',
    requestType: 2
  }
  let params = {
    Knowledge: Knowledge,
    Person: Person,
    FilePathList: fileList
  }
  return $http(getUrl, params)
}

//TODO:新增或修改知识类型
export function AddOrUpdateKnowledgeType(knowledgeType) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddOrUpdateKnowledgeType',
    requestType: 2
  }
  let params = knowledgeType
  return $http(getUrl, params)
}

//TODO:新增或者修改知识标签
export function AddOrUpdateKnowledgeTag(knowledgeTag) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddOrUpdateKnowledgeTag',
    requestType: 2
  }
  let params = knowledgeTag
  return $http(getUrl, params)
}

//TODO:新增或者修改知识分类
export function AddOrUpdateKmKnowledgeClass(knowledgeClass) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddOrUpdateKmKnowledgeClass',
    requestType: 2
  }
  let params = knowledgeClass
  return $http(getUrl, params)
}

//TODO:知识管理查询接口
export function GetKnowledgeByParam(searchPara) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/GetKnowledgeByParam',
    requestType: 2
  }
  let params = searchPara
  return $http(getUrl, params)
}
//TODO:删除知识类型
export function DeleteKnowledgeType(typeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/DeleteKnowledgeType',
    requestType: 2
  }
  let params = {
    typeId: typeId
  }
  return $http(getUrl, params)
}

//TODO:删除知识关键词
export function DeleteKmKnowledgeTag(tagId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/DeleteKmKnowledgeTag',
    requestType: 2
  }
  let params = {
    tagId: tagId
  }
  return $http(getUrl, params)
}

//TODO:删除知识分类
export function DelKmKnowledgeClass(classId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/DelKmKnowledgeClass',
    requestType: 2
  }
  let params = {
    classId: classId
  }
  return $http(getUrl, params)
}

//TODO:获取知识内容
export function GetKnowlegeBody(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetKnowlegeBody',
    requestType: 2
  }
  let params = {
    knowledgeId: knowledgeId
  }
  return $http(getUrl, params)
}

//TODO:获取产品型号
export function GetAllObjTypeBSMV() {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllObjTypeBSMV',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}
//TODO:获取常用和在线产品型号
// export function GetCommonAndUsedObjTypeBSMV() {
//     let getUrl = {
//         method: 'GET',
//         url: 'basedata/GetCommonAndUsedObjTypeBSMV',
//         requestType: 2
//     };
//     let params = {};
//     return $http(getUrl, params);
// }
//TODO:添加点赞
export function AddKmUpVote(upvote) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddKmUpVote',
    requestType: 2
  }
  let params = upvote
  return $http(getUrl, params)
}
//TODO:取消点赞
export function DeleteKmUpVote(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/DeleteKmUpVote',
    requestType: 2
  }
  let params = {
    mainId: knowledgeId,
    mainType: 0,
    userId: cookieUser.userId
  }
  return $http(getUrl, params)
}
//TODO:添加收藏
export function AddKnowledgeFocus(focusModel) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddKnowledgeFocus',
    requestType: 2
  }
  let params = focusModel
  return $http(getUrl, params)
}
//TODO:取消收藏
export function DelKnowledgeFocus(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/DelKnowledgeFocus',
    requestType: 2
  }
  let params = {
    knowledgeId: knowledgeId,
    userId: cookieUser.userId
  }
  return $http(getUrl, params)
}
//TODO:是否点赞了
export function IsUpVote(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/IsUpVote',
    requestType: 2
  }
  let params = {
    mainId: knowledgeId,
    mainType: 0,
    userId: cookieUser.userId
  }
  return $http(getUrl, params)
}
//TODO:是否关注了
export function IsFocus(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/IsFocus',
    requestType: 2
  }
  let params = {
    knowledgeId: knowledgeId,
    userId: cookieUser.userId
  }
  return $http(getUrl, params)
}
//TODO:是否添加知识评论
export function AddKnowledgeComment(comment) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddKnowledgeComment',
    requestType: 2
  }
  let params = comment
  return $http(getUrl, params)
}

//TODO:添加阅览记录
export function AddReadRecord(readRecord) {
  let getUrl = {
    method: 'POST',
    url: 'KMS/AddReadRecord',
    requestType: 2
  }
  let params = readRecord
  return $http(getUrl, params)
}
//TODO:获取知识评论
export function GetKnowledgeCommentByMainId(knowledgeId) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetKnowledgeCommentByMainId',
    requestType: 2
  }
  let params = {
    mainId: knowledgeId,
    mainType: 0
  }
  return $http(getUrl, params)
}

//TODO:通过知识ID获取知识信息
export function GetKnowledgeByIds(id) {
  let getUrl = {
    method: 'GET',
    url: 'KMS/GetKnowledgeByIds',
    requestType: 2
  }
  let params = { knowledgeId: id }
  return $http(getUrl, params)
}

//TODO:获取所有运维对象实例
export function GetAllGeneralSelTreeEx() {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllGeneralSelTreeEx',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}
//TODO:获取指定故障
export function GetEventReasonById(id) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetEventReasonById',
    requestType: 2
  };
  let params = {
    id: id
  };
  return $http(getUrl, params);
}
//TODO:获取常用、在用运维对象、产品编码
export function GetCommonAndUsedObjTypeBSMV() {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCommonAndUsedObjTypeBSMV',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}
//TODO:获取运维对象，对象实例
export function GetAllGeneralSelTreeByKeyword(
  userId,
  devTypeKeyword,
  bsmvKeyword,
  locKeyword
) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllGeneralSelTreeByKeyword',
    requestType: 2
  }
  let params = {
    userId: userId,
    devTypeKeyword: devTypeKeyword,
    bsmvKeyword: bsmvKeyword,
    locKeyword: locKeyword
  }
  return $http(getUrl, params)
}
//TODO:获取运维对象，对象实例搜索记录
export function GetObjSearchLogByUserId(userId, keyword) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetObjSearchLogByUserId',
    requestType: 2
  }
  let params = {
    userId: userId,
    keyword: keyword
  }
  return $http(getUrl, params)
}

export function GetCompanyAllGeneralSelTree(companyId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCompanyAllGeneralSelTree',
    requestType: 2
  }
  let params = {
    companyId: companyId
  }
  return $http(getUrl, params)
}
export function GetCommonGeneralNodesByUserId(userId, type) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCommonGeneralNodesByUserId',
    requestType: 2
  }
  let params = {
    userId: userId,
    type: type
  }
  return $http(getUrl, params)
}
export function GetDeviceClassCodeGeneralNodeTree(keyword, url) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/' + url,
    requestType: 2
  }
  let params = {
    keyword: keyword
  }
  return $http(getUrl, params)
}
/**
 * 根据运维对象ID，获取对应的故障分类
 */
export function GetEventReasonByObjId(objId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetEventReasonByObjId',
    requestType: 2
  }
  let params = {
    objId: objId
  }
  return $http(getUrl, params)
}
